import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { setPaymentStarted } from '@/api/payment'
import { useConsultation } from '@/hooks/useConsultation'
import { usePrescription } from '@/hooks/usePrescription'
import { useTagManager } from '@/hooks/useTagManager'
import { useUser } from '@/hooks/useUser'

enum PAYMENT_OPTIONS {
  IFRAME = 'iframe',
  NAVIGATE = 'navigate'
}

export const PrescriptionPayment = () => {
  const { t } = useTranslation()
  const { user } = useUser()
  const { updateConsultation } = useConsultation()
  const { prescription } = usePrescription()
  const { sendGTMEvent } = useTagManager()
  const [option] = useState<PAYMENT_OPTIONS>(PAYMENT_OPTIONS.NAVIGATE)
  const url = prescription?.information?.payment?.paymentUrl

  const handlePaymentStarted = async () => {
    const consultation = await setPaymentStarted({
      uniqueId: user?.data?.uniqueId!
    })
    sendGTMEvent('prescriptionRequest_proceed_to_payment')
    updateConsultation(consultation)
  }

  switch (option) {
    case PAYMENT_OPTIONS.IFRAME:
      return <iframe className="w-full grow" src={url} title="Prescription Payment" />

    case PAYMENT_OPTIONS.NAVIGATE:
      return (
        <div className="flex w-full flex-col gap-8 p-4">
          <h1 className="text-primary text-center text-2xl font-bold">{t('payment.title')}</h1>

          <p>{t('payment.before')}</p>

          <a
            href={url}
            target="_blank"
            rel="noreferrer"
            className="bg-primary w-full rounded-lg p-5 text-center font-bold text-white uppercase shadow-sm"
            onClick={handlePaymentStarted}
          >
            {t('button.pay_now')}
          </a>
        </div>
      )
  }
}
